import Layers from "../../../../../../../../src/layers/Layers";
import { eventBus, EnumEventBus } from "../../../EventBus";
import Line from "../../../../../../../../src/entities/Line/Line";
import Angle from "../../../../../../../../src/entities/Angle/Angle";
import HintFactory from "./HintFactory";
import { GridConfig } from "../../../../../../../../src/types/Interface";
import { Question } from "../../../../types/Interface";
import { QuestionType, ShapeColor } from "../../../../types/Enum";
import PivotPoint from "../../../../entities/PivotPoint";
import InfoBox from "../../../../../../../../src/entities/UI/InfoBox/InfoBox";
import { InfoBoxBgColor } from "../../../../../../../../src/entities/UI/InfoBox/Enum";
import getNonParallelLineCoords from "./helpers/getNonParallelLineCoords";


const infoBoxProps = {
  title: "HINT:",
  info: "This is a important info",
  bgColor: InfoBoxBgColor.orange,
  coord: { x: 126, y: 140 },
  width: 290,
  height: 90
}

export default class HintManager {
  private Layers = Layers.getInstance();
  private GridConfig!: GridConfig;
  private Question!: Question;
  private elements: (Line | Angle | PivotPoint)[] = [];

  constructor() {
    eventBus.on(EnumEventBus.animateHint, (v) => v ? this.showHint() : HintFactory.cancelHintAnim(this.elements));
  }

  setHint(GridConfig: GridConfig, Question: Question) {
    HintFactory.removeAll(this.elements);
    this.GridConfig = GridConfig;
    this.Question = Question;
  }
  async showHint() {
    HintFactory.removeAll(this.elements);
    this.Question.qType == QuestionType.TYPE1 ? this.showHintType1() : this.showHintType2();
  }

  async showHintType1() {
    let elements: (Line | Angle)[][] = [];

    [...this.Question.shapePoints].map((_, cI) => {
      const lines: (Line | Angle)[] = Array(2).fill("").map(() => new Line({ color: 0xf94f6f, width: 4 }));
      const angle = new Angle(`angle-${cI}`, { color: 0xf94f6f, textColor: 0xf94f6f });
      elements.push([...lines, angle]);
      this.elements.push(...lines, angle);
    });
    const shapeLines = [...this.Question.shapePoints].map(_ => new Line({ width: 5, color: 0x000000 }));
    this.elements.push(...shapeLines);

    await HintFactory.drawLinesType1(this.GridConfig, this.Question, elements)
    await HintFactory.drawRotatedShape(shapeLines, this.GridConfig, this.Question.rotatedShapePoints);
  }

  async showHintType2() {
    let Lines: Line[][] = [];
    const indexes = getNonParallelLineCoords([...this.Question.shapePoints], [...this.Question.rotatedShapePoints]);

    [...indexes].map(_ => {
      const lines = Array(2).fill(null).map(_ => new Line({ color: 0xf94f6f, width: 4 }));
      Lines.push(lines);
      this.elements.push(...lines);
    });
    const pivotPoint = this.Layers.Top.addChild(new PivotPoint(ShapeColor.red))
    this.elements.push(pivotPoint);
    HintFactory.drawLinesType2(Lines, indexes, pivotPoint, this.GridConfig, this.Question);
  }
}